import {
  DeleteJobCatalogNodeAttributeDocument,
  DeleteJobCatalogNodeAttributeMutation,
  NodePageDocument,
} from 'generated/resources/graphql'

import { useMutation } from 'modules/core/hooks/useMutation'

import {
  formatUuidToNodeType,
  getChildNodeType,
  getNodeId,
} from 'modules/job_catalog/lib/nodesUtils'

const useDeleteJobCatalogAttribute = () => {
  const [mutate, { loading }] = useMutation(DeleteJobCatalogNodeAttributeDocument, {
    extractorFn: (data: DeleteJobCatalogNodeAttributeMutation) =>
      data.jobCatalogMutations.deleteJobcatalogNodeAttribute,
  })

  const deleteAttribute = (id: string, nodeUuid: string) => {
    const nodeId = getNodeId(nodeUuid)
    const nodeType = formatUuidToNodeType(nodeUuid)
    const childType = getChildNodeType(nodeUuid)

    return mutate({
      variables: {
        id,
        nodeId,
        nodeType,
      },
      refetchQueries: [
        {
          query: NodePageDocument,
          variables: {
            nodeUuid,
            childType,
          },
        },
      ],
    })
  }

  return { deleteAttribute, loading }
}

export default useDeleteJobCatalogAttribute
